

 function showOrder(id){
    getOrder(id);
    console.log("all_orders_",id,"sdgsdgsdg")
    document.getElementById(`all_orders_content`).style.display = 'none';
    document.querySelectorAll('.single_order_block').forEach(el => {
      el.style.display = 'block';
    });
    const orderBlock = document.getElementById(`order_block_${id}`);
    if (orderBlock) {
        orderBlock.style.display = 'block';
        orderBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

function changeFlavour(flvr,bId){
    const elements = document.getElementsByClassName(`flvr--${bId}`);
    if (elements.length > 0) {
      elements[0].textContent = flvr;
    } 
}

function getOrder(id){
    const options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy' 
  }
};

const orderId = id; 
fetch(`https://api.retextion.com/api/v2/orders/${orderId}`, options)
  .then(res => {
    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
    return res.json();
  })
  .then(order => {
    console.log('Full order:', order);
  })
  .catch(err => console.error('Error fetching order:', err));

}

async function applyDiscount(subsId) {
  const discountInputElement = document.getElementById('discountCode');
  const discountCode = discountInputElement.value.trim();
  if (discountCode && subsId) {
    discountInputElement.value = '';
 try {
    const response = await fetch(`https://api.retextion.com/api/v2/subscriptions/${subsId}/add-discount`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({ redeemCode: discountCode })
    });

    const data = await response.json();
    if(data.success == true){
       window.location.reload();
    }else if(data.success == false){
       
    }
  } catch (error) {
    console.error('Error applying discount:', error.message);
  }
  }
}


async function removeDiscount(subsId,discountId) {
  if (discountId && subsId) {
 try {
    const response = await fetch(`https://api.retextion.com/api/v2/subscriptions/${subsId}/remove-discount`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({ discountId: discountId })
    });

    const data = await response.json();
    if(data.success == true){
      window.location.reload();
    }else if(data.success == false){
      console.log(data,"fail")
    }
  } catch (error) {
    console.error('Error applying discount:', error.message);
  }
  }
}


function addYouMayLike(selectId) {
  const selectElement = document.getElementById(selectId);
  
  const selectedVariantId = selectElement.value;
  const selectedOption = selectElement.selectedOptions[0];
  let subscriptionId = selectedOption?.dataset?.subscriptionid;
  if(selectedVariantId && subscriptionId){
   addLineItem(subscriptionId,selectedVariantId,7);
  }
  
}



async function orderNow(subscriptionId) {
  const token = 'tt2236q-vepulta-witu5fa-ostjtgy';
  if(!subscriptionId) return;
  const url = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}/get-order-now`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': token
      }
    });
    const data = await response.json();
    if(data.success == true){
       const popup = document.getElementById('popupp');
             popup.style.display = 'flex';
       setTimeout(() => {
             getUpcomingOrder(subscriptionId,token);
        }, 10000);         
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  } 
} 


async function getUpcomingOrder(subscriptionId,token) {
  const url = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': token
      }
    });
    const container = document.querySelector('.outer-subscription-container');
    const data = await response.json();
    renderUpcomingOrder(data);
    addSubscriptionHTML(container,data);
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}


async function getSubscriptionId(token) {
  let email = document.getElementById("customer_email_i").value;
  if(!email) return;
  const url = `https://api.retextion.com/api/v2/subscriptions/?email=${email}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': token
      }
    });
    const responseData = await response.json();
    if (responseData?.data?.[0]?.subscriptionId) {
       const subscId = responseData.data[0].subscriptionId.replace('gid://shopify/SubscriptionContract/', '');
       if(subscId){
        document.querySelector(".third-wrapper").style.display = "block";
        document.querySelectorAll('select.flavor-option_bls option').forEach(option => {
          option.setAttribute('data-subscriptionid', `${subscId}`);
        });

       }
       getUpcomingOrder(subscId,token);
     }else{
       const messageEl = document.querySelector('.no_subscription');
          if (messageEl) {
            messageEl.style.display = 'flex';
            messageEl.textContent = 'THERE IS NO SUBSCRIPTION';
          }
     }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

function renderUpcomingOrder(data) {
  const container = document.getElementById('upcoming_order_block');
  if (!container) return;

  console.log(data, "Incoming Data");
  const { customer, nextBillingDate, lines, deliveryPrice, deliveryMethod, currencyCode, id, discounts } = data;
  const shipmentDate = new Date(nextBillingDate).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });
  const productCards = lines.map(line => `
    <div class="subscription-item upcoming-orders-card">
      <div class="image-text">
        <img src="${line.variantImage?.originalSrc || ''}" alt="${line.title}">
      </div>
      <div class="meta">
        <h3>${line.title}</h3>
        <p class="variant-dropdown">
          ${line.variantTitle}
        </p>
        <p class="price">${currencyCode} ${parseFloat(line.currentPrice.amount).toFixed(2)}</p>
        <p>Quantity: ${line.quantity}</p>
      </div>
      <a href="javascript:void(0)" class="edit-link edit-upcoming-order">Edit</a>
    </div>
  `).join('');
  const subtotal = lines.reduce((sum, l) => sum + parseFloat(l.currentPrice.amount) * l.quantity, 0);
  const shipping = parseFloat(deliveryPrice.amount);
  let discountValue = 0;
  let discountLabel = `0.00`;
  let discountTitle = '';
  if (discounts?.edges?.length) {
    const discountNode = discounts.edges[0].node;
    discountTitle = discountNode.title || '';
    if (discountNode.value?.percentage) {
      const percentage = discountNode.value.percentage;
      if (discountNode.targetType === 'SHIPPING_LINE') {
        discountValue = shipping * (percentage / 100);
      } else {
        discountValue = subtotal * (percentage / 100);
      }
    } 
    else if (discountNode.value?.amount) {
      const fixedAmount = parseFloat(discountNode.value.amount.amount);
      if (discountNode.targetType === 'SHIPPING_LINE') {
        discountValue = Math.min(fixedAmount, shipping); 
      } else {
        discountValue = Math.min(fixedAmount, subtotal);
      }
    }
    discountLabel = discountValue.toFixed(2);
  }
  const total = subtotal + shipping - discountValue;
  const d = new Date();
  const html = `
    <div class="wrap">
      <!-- Popup for order update -->
      <div class="popup-overlay" id="popupp">
        <div class="popup-box">
          <button class="close_all">×</button>
          <h2>Set next order date</h2>
          <p>
            We got it! Your order has been updated for ${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')}/${d.getFullYear()}. This action may take a few minutes to show on your account summary.
          </p>
          <p>Thanks</p>
        </div>
      </div>

      <!-- Welcome block -->
      <div class="welcome_block">
        <div class="upper_lift">
          <div class="welcome-customer">Upcoming Orders - <span>#${id.replace('gid://shopify/SubscriptionContract/', '')}</span></div>
          <div class="custom-btn-order">
            <a href="javascript:void(0)" onclick="orderNow('${id.replace('gid://shopify/SubscriptionContract/', '')}')">Order Now</a>
          </div>
        </div>
        <p class="thankyou_message">Next Shipment ${shipmentDate}</p>
      </div>

      <!-- Product cards -->
      ${productCards}

      <!-- Summary block -->
      <div class="summary-container order-elavorted">
        <div class="summary-roww">
          <span class="label muted">Subtotal</span>
          <span class="value muted">${currencyCode} ${subtotal.toFixed(2)}</span>
        </div>
        <div class="summary-roww">
          <span class="label muted">Discount (${discountTitle})</span>
          <span class="value muted">${currencyCode} ${discountLabel}</span>
        </div>
        <div class="summary-roww">
          <span class="label muted">Shipping</span>
          <span class="value muted">${currencyCode} ${shipping.toFixed(2)}</span>
        </div>
        <div class="summary-notee"><em>Taxes Calculated At Time Of Order</em></div>
        <div class="summary-roww total">
          <span class="label bold">Total</span>
          <span class="value bold">${currencyCode} ${total.toFixed(2)}</span>
        </div>
      </div>

      <!-- Shipping information -->
      <div class="shipping-info upcoming-history">
        <div class="info-block">
          <div class="info-header">
            <strong>Shipping Information</strong>
            <a href="https://flowpouch.com/account/addresses" class="edit-link">Edit</a>
          </div>
          <div class="info-content">
            <p>${deliveryMethod.address.address1} ${deliveryMethod.address.city}</p>
            <p>${deliveryMethod.address.zip}</p>
          </div>
        </div>
      </div>
    </div>
  `;
  container.innerHTML = html;
  const popup = document.getElementById('popupp');
  const closeAll = document.querySelector('.close_all');
  closeAll.addEventListener('click', () => {
    popup.style.display = 'none';
  });
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });
}

async function generatePortalLink(){
  let email = document.getElementById("customer_email_i").value;
  if(!email) return;
  const url = `https://api.retextion.com/api/v2/subscriptions/generate-portal-link`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({ email: email })
    });

    const data = await response.json();
    if(data && data.link){
      window.location.href = data.link;
    }else{
      window.location.href = window.location.origin + "/account/addresses";
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

function nextOrderDate(subsId,date){
 const url = `https://api.retextion.com/api/v2/subscriptions/${subsId}/set-next-billing-date`;
  fetch(url, {
  method: 'POST',
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
    'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
  },
  body: JSON.stringify({ nextBillingDate: date })
   })
  .then(response => {
    if (response.ok) {
      window.location.reload();
    } else {
      response.text().then(text => {
        try {
          const data = JSON.parse(text);
          console.error('Failed to update:', data);
        } catch {
          console.error('Failed to update, response:', text);
        }
      });
    }
  })
  .catch(error => {
    console.error('Error fetching subscription:', error.message);
  });
}

async function reActivateSubcription(subsId){
  const url = `https://api.retextion.com/api/v2/subscriptions/${subsId}/reactivate`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({initiator: 'CUSTOMER'})
    });

    const data = await response.json();
    if(data.success){
      window.location.reload();
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

async function cancelSubcription(subsId){
  const url = `https://api.retextion.com/api/v2/subscriptions/${subsId}/cancel`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({initiator: 'CUSTOMER'})
    });

    const data = await response.json();
    if(data.success){
      window.location.reload();
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

async function addSubscriptionHTML(container, subscription) {
    const subBox = document.createElement('div');
    const focusDiv = document.createElement('div');
    const contentContainer = document.createElement('div');
    const fiveTabs = document.createElement('div');
    const subsStatus = subscription.status.status;
    console.log(subsStatus,"subsStatussubsStatus")
    subBox.classList.add('subscription-box');
    subBox.innerHTML = `
        <div class="subscription-info">
            <h3 class="${subsStatus}">Subscription <span>#${subscription.id.split('/').pop()}</span></h3>
            <p>Next Shipment ${new Date(subscription.nextBillingDate).toLocaleDateString()}</p>
            <button class="get-btnn" style="display:none;">GET IT NOW</button>
        </div>
    `;

    focusDiv.classList.add('focus-section');
    focusDiv.innerHTML = `
        <div class="focus-content">
            <h2>Pure focus in every pouch</h2>
            <p>A natural & healthy alternative to nicotine and caffeine pouches.</p>
            <a href="https://flowpouch.com/products/flow-pouches-special-promo" class="btn-upgrade">UPGRADE NOW</a>
        </div>
    `;

    contentContainer.classList.add('content_container');

    let priceInUSD = 25;
    if(subscription.lines.length >= 7){
       priceInUSD = 8.63;
    }else if(subscription.lines.length >= 3){
      priceInUSD = 12.25;
    }    
    priceInUSD = 7;
    const rates = { USD: 1, EUR: 0.93, GBP: 0.82, CZK: 21.173 };
    // const priceOfFirst = `$${priceInUSD.toFixed(2)}`;
    const priceOfFirst = `$7.00`;
 
    // --- 🧾 Generate HTML for subscription line items ---
    const lineItemsHTML = subscription.lines
        .map(item => `
            <div class="subscription-item">
                <div class="image-text">
                    <img src="${item.variantImage.originalSrc}" alt="${item.variantImage.altText || item.title}">
                </div>
                <div class="meta">
                    <h3>${item.title}</h3>
                    <div class="variant_selected">${item.variantTitle}</div>
                    <p class="price">${subscription.currencyCode} ${parseFloat(item.currentPrice.amount).toFixed(2)}</p>
                    <p>Quantity: ${item.quantity}</p>
                </div>
            </div>
        `)
        .join('');

    // --- 💰 Calculate Subtotal ---
    const subtotal = subscription.lines.reduce(
        (sum, i) => sum + parseFloat(i.currentPrice.amount) * i.quantity,
        0
    );

    // --- 🚚 Shipping ---
    let shipping = parseFloat(subscription.deliveryPrice.amount);

    // --- 🎟️ Calculate Discounts ---
    let discountAmount = 0;
    let discountLabel = 'No discount applied';
    let discountId = '';
    if (subscription.discounts && subscription.discounts.edges.length > 0) {
        for (const edge of subscription.discounts.edges) {
            const discountNode = edge.node;
            const { value, title, targetType, id } = discountNode;
            discountId = id;
            if (targetType === 'SHIPPING_LINE') {
                // Shipping discount (like FREESHIP)
                if (value.percentage){
                    discountAmount = shipping * ( value.percentage / 100 );
                    discountLabel = `${title}`;
                } else if (value.amount) {
                    const shipDisc = parseFloat(value.amount.amount);
                    shipping = Math.max(0, shipping - shipDisc);
                    discountAmount += shipDisc;
                    discountLabel = `${title}`;
                }
            } else {
                // Product/order discount
                if (value.percentage) {
                    const percentage = value.percentage;
                    const itemDisc = subtotal * (percentage / 100);
                    discountAmount += itemDisc;
                    discountLabel = `${title}`;
                } else if (value.amount) {
                    const amt = parseFloat(value.amount.amount);
                    discountAmount += amt;
                    discountLabel = `${title}`;
                }
            }
        }
    }

    // --- 🧮 Calculate Total ---
    const total = subtotal - discountAmount + shipping;
    // --- 🏗️ Build the content container ---
    contentContainer.innerHTML = `
        <div class="wrap">

            <div class="blossom_coder_buttons">
                <a href="javascript:void(0)" class="btn btn-primary">
                    Next Shipment ${new Date(subscription.nextBillingDate).toLocaleDateString()}
                </a>
                <a href="javascript:void(0)" class="btn btn-secondary">
                    ${subscription.currencyCode} ${(subtotal * 0.1).toFixed(2)} saved by subscribing
                </a>
            </div>

            <div class="subscription-details">
                <h2>Subscription Details</h2>
                <div class="subscription-grid">
                    ${lineItemsHTML}
                </div>
            </div>

            <div class="discount-container">
                <div class="discount-label">
                    <h2>Discount Code</h2>
                    <p class="apply-discount-btnn">Apply Discount Code</p>
                </div>
                <div class="discount-input">
                    <input type="text" id="discountCode" value="">
                    <button onclick="applyDiscount('${subscription.id.split('/').pop()}')">Apply Now</button>
                </div>
                ${discountAmount > 0 ? `
                    <div class="active-discount">
                        <strong>${discountLabel}</strong><svg onclick="removeDiscount('${subscription.id.split('/').pop()}','${discountId}')" class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiChip-deleteIcon MuiChip-deleteIconMedium MuiChip-deleteIconColorDefault MuiChip-deleteIconOutlinedColorDefault css-w6pf6c" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                    </div>
                ` : ''}
            </div>

            <div class="summary-container">
                <div class="summary-roww">
                    <span class="label muted">Subtotal</span>
                    <span class="value muted">${subscription.currencyCode} ${subtotal.toFixed(2)}</span>
                </div>
                <div class="summary-roww">
                    <span class="label muted">Discount</span>
                    <span class="value muted">${discountAmount > 0 ? `-${subscription.currencyCode} ${discountAmount.toFixed(2)}` : '0.00'}</span>
                </div>
                <div class="summary-roww">
                    <span class="label muted">Shipping</span>
                    <span class="value muted">${subscription.currencyCode} ${shipping.toFixed(2)}</span>
                </div>
                <div class="summary-notee">
                    <em>Taxes Calculated At Time Of Order</em>
                </div>
                <div class="summary-roww total">
                    <span class="label bold">Est. Total</span>
                    <span class="value bold">${subscription.currencyCode} ${total.toFixed(2)}</span>
                </div>
            </div>

            <div class="shipping-info">
                <div class="info-block">
                    <div class="info-header">
                        <strong>Shipping Information</strong>
                        <a href="https://flowpouch.com/account/addresses" class="edit-link">Edit</a>
                    </div>
                    <div class="info-content">
                        <p>${subscription.deliveryMethod.address.address1}, ${subscription.deliveryMethod.address.city}</p>
                        <p>${subscription.deliveryMethod.address.zip}, ${subscription.deliveryMethod.address.country}</p>
                    </div>
                </div>
            </div>
        </div>
    `;
    

    fiveTabs.classList.add('five_main_tabs');
    fiveTabs.innerHTML = `
       <div class="content_container five_main_tabs">
    <div class="wrap">
      <div class="custom-img-text">
        <div class="img-text-block">
          <button class="get-btn">
            <img src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_1707484674_46cb23f2-132b-465d-b22e-b1a797718dc2.png?v=1762318209">
            <h2>Get Now</h2>
          </button>
        </div>

        <div class="popup-overlay" id="popupp-new">
          <div class="popup-box">
            <h2>Get Now</h2>
            <p>
              This will <strong>Place Your Next Order Now</strong><br>
              And set the following order to 4 weeks from now.<br>
              Are you sure?
            </p>
            <button class="confirm-btnn" onclick="orderNow('${subscription.id.split('/').pop()}')">Confirm</button>
          </div>
        </div>

        
        <div class="popup-overlay" id="popupp-new-note">
          <div class="popup-box">
            <h2>Get Note</h2>
            <p>
               sdsgds sadgsdgsdgsdg
            </p>
            <button class="confirm-btnn" id="confirm-btnn-note">Confirm</button>
          </div>
        </div>


        <div class="img-text-block">
          <button class="next-order" >
            <img src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_1707484673.png?v=1760777918" alt="">
            <h2>Next Order Date</h2>
          </button>
        </div>

        <!-- Popup -->
        <div class="datepicker-overlay" id="datepickerOverlay">
        <div class="datepicker-popup">
        <button class="close-btn" id="closePopup">&times;</button>
        <h3>Set Your Next Order Date</h3>
        <div class="month" id="monthLabel"></div>
        <div class="calendar">
          <input type="date" id="calendar" />
        </div>
        <button class="confirm-btn" id="confirmBtn">Confirm</button>
        </div>
        </div>

        <div class="img-text-block">
          <button class="skip-button">
            <img src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_1707484672_7a954674-ac4e-4f2f-b6d9-5e84568b435f.png?v=1762318209">
            <h2>Skip</h2>
          </button>
        </div>

        <div class="skip-popup">
          <div class="popup-content">
            <div class="custom-close-heading">
              <button class="close-btn">&times;</button>
              <h3>Skip Next Order</h3>
            </div>
            <p>
              This will delay your order by the amount of time you select below . are you sure ? You can also gift your
              next subscription order instead of skipping
            </p>
            <button style="display:none;">Gift Order</button>
            <button onclick="skipNextOrder('${subscription.id.split('/').pop()}',1)">Skip 1 Week</button>
            <button onclick="skipNextOrder('${subscription.id.split('/').pop()}',2)">Skip 2 Weeks</button>
            <button onclick="skipNextOrder('${subscription.id.split('/').pop()}',4)">Skip 4 Weeks</button>
          </div>
        </div>

        <div class="img-text-block">
          <button class="edit-product">
            <img src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_1707484671_3895afc9-4829-4a1a-91c3-f21627a75148.png?v=1762318209">
            <h2>Edit Products</h2>
          </button>
        </div>

  <div class="edit-product-popup">
  <div class="edit-product-content">
    <button class="edit-product-close">&times;</button>
    <h3 class="edit-product-title">Manage Products</h3>
    <div class="edit-product-list">
      <div class="custom-edit-products" id="editProductsContainer_${subscription.id.split('/').pop()}">
        
      </div>

      <button class="edit-product-add" style="display:none">Add Product(s) To Subscription</button>

      <div class="bottom-wrapper">
        <h2 class="bottom-wrapper-heading">Add to your next order</h2>

        <div class="product-cardd">
          <div class="card-headerr">
            <div class="product-details">
              <h3>Flow Pouches</h3>
              <p class="flavor flvr-add-next">Cool Mint</p>
              <p class="price">${priceOfFirst}</p>
            </div>
            <img id="flavor-image-next" src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/1_edf22d8f-7c95-49f1-b085-ab08375db7ac.png?v=1761928154" class="product-image">
          </div>
          <div class="card-footer">
            <button class="add-btn add-btn-next" >+</button>
            <select class="flavor-select"
              id="selected_variant_add-next"
             >
                <option value="49788442149145" data-name="Wintergreen" subscriptionId="${subscription.id.split('/').pop()}">Wintergreen</option>
                <option value="49788442181913" data-name="Cool Mint" subscriptionId="${subscription.id.split('/').pop()}">Cool Mint</option>
                <option value="50380942213401" data-name="Blue Razz" subscriptionId="${subscription.id.split('/').pop()}">Blue Razz</option>
                <option value="50380942246169" data-name="Sour Apple" subscriptionId="${subscription.id.split('/').pop()}">Sour Apple</option> 
                <option value="50380942278937" data-name="Citrus" subscriptionId="${subscription.id.split('/').pop()}">Citrus</option>
                <option value="50678337175833" data-name="Black Cherry" subscriptionId="${subscription.id.split('/').pop()}">Black Cherry</option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <div class="edit-product-total">
      <h4>Total</h4>
      <span id="editTotal_${subscription.id.split('/').pop()}">$0.00</span>
    </div>

    <button class="edit-product-save">Save Changes</button>
  </div>
 </div>


        <div class="img-text-block discount-dropdown">
          <button class="apply-discount-btn">
            <img src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_1707484670_a629781a-150d-4db1-9896-46f5850421d6.png?v=1762318210">
            <h2>More</h2>
          </button>
         <div class="discount-popup-overlay">
          <div class="discount-popup-box">
            <div class="activate-subscription" onclick="reActivateSubcription('${subscription.id.split('/').pop()}')"><h2>Reactivate Cancelled Subscription</h2></div>
            <div class="cancel-subscription" id="cancel-subscription"><h2>Cancel Subscription</h2></div>
          </div>
        </div>
          </div>

      </div>
    </div>
  </div>
     `;
     
   //onclick="cancelSubcription('${subscription.id.split('/').pop()}')"

     
    container.appendChild(subBox);
    container.appendChild(focusDiv);
    container.appendChild(contentContainer);
    
    container.appendChild(fiveTabs);
 // --- 🧩 Dynamic Edit Product Popup ---
  const editContainer = document.getElementById(`editProductsContainer_${subscription.id.split('/').pop()}`);
  const editTotalEl = document.getElementById(`editTotal_${subscription.id.split('/').pop()}`);
  const saveBtn = fiveTabs.querySelector('.edit-product-save');

  let editableLines = JSON.parse(JSON.stringify(subscription.lines));
  let deletedItemIds = [];

// Render dynamic products
 function renderEditProducts() {
  let totalPrice = 0;
  editContainer.innerHTML = editableLines.map((item, index) => {
    const itemTotal = parseFloat(item.currentPrice.amount) * item.quantity;
    totalPrice += itemTotal;

    return `
      <div class="image-text edit-item" data-index="${index}" data-line-id="${item.id.split('/').pop()}">
        <img src="${item.variantImage.originalSrc}" alt="${item.variantImage.altText || item.title}">
        <div class="meta">
          <h3>${item.title}</h3>
          
            <p selected>${item.variantTitle}</p>
          
          <p class="price">${subscription.currencyCode} ${parseFloat(item.currentPrice.amount).toFixed(2)}</p>
          <div class="quantity-box">
            <button class="qty-btn minus">-</button>
            <input type="number" value="${item.quantity}" min="1" class="qty-input">
            <button class="qty-btn plus">+</button>
          </div>
        </div>
        <img class="delete-button" lineId="${item.id}" src="https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Trash.png?v=1761285320">
      </div>
    `;
  }).join('');

  editTotalEl.textContent = `${subscription.currencyCode} ${totalPrice.toFixed(2)}`;

  // Add quantity controls + delete logic
  editContainer.querySelectorAll('.edit-item').forEach((el, idx) => {
    const qtyInput = el.querySelector('.qty-input');
    const minusBtn = el.querySelector('.minus');
    const plusBtn = el.querySelector('.plus');
    const deleteBtn = el.querySelector('.delete-button');

    minusBtn.addEventListener('click', () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
      editableLines[idx].quantity = parseInt(qtyInput.value);
      updateTotal();
    });
    plusBtn.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      editableLines[idx].quantity = parseInt(qtyInput.value);
      updateTotal();
    });
    qtyInput.addEventListener('input', () => {
      editableLines[idx].quantity = parseInt(qtyInput.value);
      updateTotal();
    });
    deleteBtn.addEventListener('click', () => {
      const deletedItem = editableLines[idx];
      if (deletedItem) {
        deletedItemIds.push(deletedItem.id); 
      }
      editableLines.splice(idx, 1);
      renderEditProducts();
    });
  });
}

// Recalculate total dynamically
function updateTotal() {
  let total = 0;
  editableLines.forEach((item) => {
    total += parseFloat(item.currentPrice.amount) * item.quantity;
  });
  editTotalEl.textContent = `${subscription.currencyCode} ${total.toFixed(2)}`;
}

// --- 💾 Save Changes (API Integration) ---
saveBtn.addEventListener('click', async () => {
  const subscriptionId = subscription.id.split('/').pop();
  if(deletedItemIds.length >=1 ){
     removeLineItem(`${subscription.id.split('/').pop()}`,deletedItemIds);
  }
  for (const item of editableLines) {
    const lineId = item.id.split('/').pop();
    const bodyData = {
      price: parseFloat(item.currentPrice.amount),
      quantity: item.quantity
    };
    // console.log(subscriptionId, " : ",lineId," : ",bodyData)
    const options = {
      method: 'PUT',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify(bodyData)
    };

    const apiUrl = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}/lines/${lineId}`;

    try {
      const res = await fetch(apiUrl, options);
      const result = await res.json();
      if(result){
        window.location.reload();
      }
    } catch (err) {
      console.error('Error updating line:', lineId, err);
    }
  }
});

renderEditProducts();
const flavorImages = {
    "49788442149145": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_18.png?v=1756554926",
    "49788442181913": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_14.png?v=1756555108",
    "50380942213401": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_15.png?v=1756555108",
    "50380942246169": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_13.png?v=1756555108",
    "50380942278937": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_16.png?v=1756555108",
    "50678337175833": "https://cdn.shopify.com/s/files/1/0898/8983/3241/files/Frame_17.png?v=1756555385"
};

const selectElement = document.getElementById('selected_variant_add-next');
const addButton = document.querySelector('.add-btn-next');

addButton.addEventListener('click', function() {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const selectedValue = selectedOption.value;
    const subscId = selectedOption.getAttribute('subscriptionId');
    addLineItem(subscId,selectedValue,priceInUSD);
});

selectElement.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    const selectedName = selectedOption.getAttribute('data-name');
    // const img = document.getElementById('flavor-image-next');
    // if (flavorImages[this.value]) {
    //     img.src = flavorImages[this.value];
    // }
    const flavorElements = document.querySelectorAll('.flvr-add-next');
    flavorElements.forEach(element => {
        element.innerHTML = selectedName;
    });
});



    const getBtn = document.querySelector('.get-btn');
    const popup = document.getElementById('popupp-new');
    const confirmBtn = document.querySelector('.confirm-btnn');
  // GET It Now Tab
  getBtn.addEventListener('click', () => {
    popup.style.display = 'flex';
  });
  confirmBtn.addEventListener('click', () => {
    popup.style.display = 'none';
    alert('Order Placed!');
  });
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });
  // // GET Note Tab
  //  const getBtnNote = document.querySelector('.get-btn');
  //  const popupNote = document.getElementById('popupp-new-note');
  //  const confirmBtnNote = document.getElementById('confirm-btnn-note');
  //  getBtnNote.addEventListener('click', () => {
  //   popupNote.style.display = 'flex';
  //  });
  // confirmBtnNote.addEventListener('click', () => {
  //   popupNote.style.display = 'none';
  // });
  // popupNote.addEventListener('click', (e) => {
  //   if (e.target === popupNote) {
  //     popupNote.style.display = 'none';
  //   }
  // });

  // Next Order Date Tab
  const nextOrder = document.querySelector('.next-order');
  const popupOverlay = document.getElementById('datepickerOverlay');
  const confirmBtnn = document.getElementById('confirmBtn');
  const closePopup = document.getElementById('closePopup');
  const calendar = document.getElementById('calendar');

  const today = new Date().toISOString().split('T')[0];
  calendar.min = today;

  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 2);
  const maxISO = maxDate.toISOString().split('T')[0];
  calendar.max = maxISO;

  nextOrder.addEventListener('click', () => {
    popupOverlay.style.display = 'flex';
  });
  confirmBtnn.addEventListener('click', function () {
        const selectedDate = calendar.value;
         if (selectedDate) {
             nextOrderDate(`${subscription.id.split('/').pop()}`,selectedDate);
         }
        popupOverlay.style.display = 'none';
  });
   closePopup.addEventListener('click', function () {
        popupOverlay.style.display = 'none';
  });
  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });


 // 
    const buttonApply = document.querySelector('.apply-discount-btn');
    const dropdownOverlay = document.querySelector('.discount-popup-overlay');
    buttonApply.addEventListener('click', function (e) {
      dropdownOverlay.classList.toggle('active');
    });
    dropdownOverlay.addEventListener('click', (e) => {
    if (e.target === dropdownOverlay) {
      dropdownOverlay.classList.remove('active');
    }
  });
}

async function removeLineItem(subscriptionId, lineIds) {
  const url = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}/remove-lines`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy' 
      },
      body: JSON.stringify({ lines: lineIds })
    });

    const data = await response.json();
    console.log(data, "remove line item.");
    if (data) {
      window.location.reload();
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}



async function addLineItem(subscriptionId,vId,price) {
  const url = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}/add-lines`;
  const variantId = `gid://shopify/ProductVariant/${vId}`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
       body: JSON.stringify({
         lines: [{variantId: variantId, price: price, quantity: 1, isOneTime: false}]
        })
    });

    const data = await response.json();
    if(data.success == true){
      window.location.reload();
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

async function skipNextOrder(subscriptionId,interval) {
  const url = `https://api.retextion.com/api/v2/subscriptions/${subscriptionId}/change-frequency`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',  
        'X-RETEXTION-ACCESS-TOKEN': 'tt2236q-vepulta-witu5fa-ostjtgy'
      },
      body: JSON.stringify({interval: interval, intervalUnit: 'week', initiator: 'CUSTOMER'})
    });

    const data = await response.json(); 
    if(data){
      window.location.reload();
    }
  } catch (error) {
    console.error('Error fetching subscription:', error.message);
  }
}

const dropdownBtn = document.querySelector('.dropdown-btn');
const dropdownContent = document.querySelector('.dropdown-content');

dropdownBtn.addEventListener('click', () => {
  dropdownContent.style.display = dropdownContent.style.display === 'flex' ? 'none' : 'flex';
});

document.addEventListener("DOMContentLoaded", () => {
    const token = 'tt2236q-vepulta-witu5fa-ostjtgy';
    getSubscriptionId(token);
});






  function waitForCancelButton() {
    const btn = document.getElementById("cancel-subscription");
    if (!btn) {
      setTimeout(waitForCancelButton, 300);
      return;
    }

    btn.addEventListener("click", cancel);
  }

  async function getSubscriptionIdd(token) {
    const emailInput = document.getElementById("customer_email_i");
    if (!emailInput?.value) return;

    const url = `https://api.retextion.com/api/v2/subscriptions/?email=${emailInput.value}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "X-RETEXTION-ACCESS-TOKEN": token,
        },
      });

      const data = await response.json();
      return data?.data?.[0]?.subscriptionId?.replace(
        "gid://shopify/SubscriptionContract/",
        ""
      );
    } catch (e) {
      console.error("Subscription fetch failed", e);
    }
  }

  async function cancel() {
    if (!window.ProsperStack?.flow) {
      console.error("ProsperStack not loaded");
      return;
    }

    const token = "tt2236q-vepulta-witu5fa-ostjtgy";
    const subsId = await getSubscriptionIdd(token);
    if (!subsId) return;

    const payload = {
      clientId: "acct_WpCJOhxEKSX4M9MjDKCW1u3g",
      subscriber: {
        internalId: "0112",
        name: "Jane Smith2",
        email: "jan2e@example.com",
      },
      subscription: {
        platformId: subsId,
        mrr: 99,
        trial: false,
      },
    };

    try {
      const res = await fetch(
        "https://cf-backend.sweet-wave-d8da.workers.dev/prosper-stack/generate-signature",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ payload: JSON.stringify(payload) }),
        }
      );

      const { signature, payload: signedPayload } = await res.json();
      if (!signature || !signedPayload) return;

      await window.ProsperStack.flow({
        payload: signedPayload,
        signature,
      });
    } catch (err) {
      console.error("ProsperStack flow error", err);
    }
  }

  // wait until the div exists
  document.addEventListener("DOMContentLoaded", waitForCancelButton);
